import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-cargar-foto',
  imports: [],
  templateUrl: './cargar-foto.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cargar-foto.css',
})
export class CargarFoto {

}
